<div class="container d-flex flex-column align-items-center justify-content-center" [class.dark-mode]="isDarkMode">
  @if (!isDam) {
    <div class="text-center p-4 max-width-400" >
      @if (channel != 6) {
        <i
      class="{{ aprobedpayment ? 'iconaprob' : 'iconaprobRec' }} lni {{
        aprobedpayment ? 'lni-checkmark-circle' : 'lni-cross-circle'
      }}"
        ></i>
      }
      @if (channel == 6) {
        <div>
          @if (aprobedpayment === true) {
            <svg  class="iconaprob" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg"> <path d="M2 12.3906C2 6.86778 6.47715 2.39062 12 2.39062C17.5228 2.39062 22 6.86778 22 12.3906C22 17.9135 17.5228 22.3906 12 22.3906C6.47715 22.3906 2 17.9135 2 12.3906ZM15.5071 9.85447C15.2142 9.56158 14.7393 9.56158 14.4464 9.85447L10.9649 13.336L9.55359 11.9247C9.2607 11.6318 8.78582 11.6318 8.49293 11.9247C8.20004 12.2176 8.20004 12.6925 8.49294 12.9854L10.4346 14.927C10.7275 15.2199 11.2023 15.2199 11.4952 14.927L15.5071 10.9151C15.8 10.6222 15.8 10.1474 15.5071 9.85447Z"/> </svg>
          }
          @if (aprobedpayment === false) {
            <svg class="iconaprobRec" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg"> <path d="M2 12.3906C2 6.86778 6.47715 2.39062 12 2.39062C17.5228 2.39062 22 6.86778 22 12.3906C22 17.9135 17.5228 22.3906 12 22.3906C6.47715 22.3906 2 17.9135 2 12.3906ZM8.78362 10.2354L10.9388 12.3906L8.78362 14.5458C8.49073 14.8387 8.49073 15.3136 8.78362 15.6065C9.07652 15.8994 9.55139 15.8994 9.84428 15.6065L11.9995 13.4513L14.1546 15.6064C14.4475 15.8993 14.9224 15.8993 15.2153 15.6064C15.5082 15.3135 15.5082 14.8387 15.2153 14.5458L13.0602 12.3906L15.2153 10.2355C15.5082 9.94258 15.5082 9.46771 15.2153 9.17482C14.9224 8.88192 14.4475 8.88192 14.1546 9.17482L11.9995 11.33L9.84428 9.17475C9.55139 8.88186 9.07652 8.88186 8.78362 9.17475C8.49073 9.46764 8.49073 9.94251 8.78362 10.2354Z"/> </svg>
          }
        </div>
      }
      <h3 class="m-3 boldtext">{{ titlepayment }}</h3>
      @if (channel !== 6) {
        <p>
          {{ getLabel('approvedMessage') }}
        </p>
      }
    </div>
  }
  @if (this.rejectReason != '') {
    <label class="mt-3 text-start w-100 " style="max-width: 400px">{{getLabel('reasonRejection')}}</label>
  }
  @if (this.rejectReason != '') {
    <div class="row w-100 max-width-400">
      <p>
        {{this.rejectReason}}
      </p>
    </div>
  }
  <label class="mt-3 text-start w-100 max-width-400"
    >{{ getLabel('transactionDetail') }}</label
    >
    <div class="row w-100 transationdiv max-width-400" >
      <div style="display: flex;" class="col text-start">{{ getLabel('transation') }}:</div>
      <div class="col-6 text-end {{aprobedpayment ? 'aprobtext' : 'declinedtext'}} boldtext">
        {{ estatuspayment }}
      </div>
    </div>
    @if (this.phoneNumber && this.phoneNumber !== 'null' && this.channel !== 7) {
      <div class="row w-100 transationdiv max-width-400" >
        <div style="display: flex;" class="col text-start">{{ getLabel('phone') }}:</div>
        <div class="col-6 text-end">{{ this.phoneNumber }}</div>
      </div>
    }
    @if (channel === 7) {
      @for (item of arraylabels | keyvalue; track item) {
        <div class="row w-100 transationdiv max-width-400"  >
          <div style="display: flex;" class="col text-start">{{ item.key }}:</div>
          <div class="col-6 text-end" >{{ item.value }}</div>
        </div>
      }
    }
    <div class="row w-100 transationdiv max-width-400">
      <div style="display: flex;" class="col text-start">{{getLabel('amountPaid')}}:</div>
      <div class="col-6 text-end">{{ currencySymbol}} {{ currintpayment }}</div>
    </div>
    @if (numberauth) {
      <div class="row w-100 transationdiv max-width-400">
        <div style="display: flex;" class="col text-start">{{getLabel('referenceTransation')}}:</div>
        <div class="col-6 text-end" style="overflow-wrap: anywhere;">{{ numberauth }}</div>
      </div>
    }
    @if (approvalCode) {
      <div class="row w-100 transationdiv max-width-400">
        <div style="display: flex;" class="col text-start">{{getLabel('authorizationCode')}}:</div>
        <div class="col-6 text-end" style="overflow-wrap: anywhere;">{{ approvalCode }}</div>
      </div>
    }
    <div class="row w-100 transationdiv max-width-400">
      <div style="display: flex;" class="col text-start">{{getLabel('dateTime')}}:</div>
      <div class="col-6 text-end" >{{ datepayment }}</div>
    </div>
    @if (!isDam) {
      <div class="row w-100 text-center align-items-center justify-content-center max-width-400">
        @if (aprobedpayment) {
          <p class="mt-3 boldtext">
            {{ getLabel('approvedMessageEmail') }}
          </p>
        }
        @if (isNationalCard) {
          <p class="mt-3 boldtext text-danger">
            {{ getLabel('messageDAM') }}
          </p>
        }
        @if (isErrorDomiciliation) {
          <p class="mt-3 boldtext text-danger">
            {{MessageDomiciliation}}
          </p>
        }
      </div>
    }
  </div>
